const MONO_APPROX_CHAR_WIDTH = 7.8;

const MAX_NODE_WIDTH = 280;
const MIN_NODE_WIDTH = 120;
const CARD_PADDING_X = 10;
const ICON_WIDTH = 16;
const ICON_GAP = 6;
export const OBJECT_NODE_HEIGHT = 64;
const USER_NODE_WIDTH = 240;
const USER_NODE_HEIGHT = 80;

const OBJECT_NODE_CHROME_X = ICON_WIDTH + ICON_GAP + CARD_PADDING_X * 2;

function clampCardWidth(naturalTextWidth: number, chromeX = OBJECT_NODE_CHROME_X): number {
	const computed = Math.ceil(naturalTextWidth + chromeX);
	return Math.max(MIN_NODE_WIDTH, Math.min(computed, MAX_NODE_WIDTH));
}

function estimateTextWidth(title: string | null | undefined): number {
	const normalized = title?.trim() ?? '';
	if (normalized.length === 0) {
		return 72;
	}
	return normalized.length * MONO_APPROX_CHAR_WIDTH;
}

export function estimateObjectNodeWidth(
	title: string | null | undefined,
	chromeX: number = OBJECT_NODE_CHROME_X,
): number {
	return clampCardWidth(estimateTextWidth(title), chromeX);
}

export function estimateLayoutNodeSize(input: {
	typename: string;
	title: string | null | undefined;
}): { width: number; height: number } {
	if (input.typename === 'AtlassianUser' || input.typename === 'identity:user') {
		return { width: USER_NODE_WIDTH, height: USER_NODE_HEIGHT };
	}

	return {
		width: estimateObjectNodeWidth(input.title),
		height: OBJECT_NODE_HEIGHT,
	};
}
